import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import vendor from "./vendor";
import userData from "./userData";
import notifications from "./notifications";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    vendor,
    userData,
    notifications,
  },
  strict: process.env.DEV,
});
